import { useMemo } from "react";
import { ChapterAttributes, Page } from "../../app/types";
import { CourseState } from "./courseSlice";

const inactiveColor = "#d4d4d4";

export const useProgressCrumbs = (
  chapter: ChapterAttributes | undefined,
  pages: Page[] | undefined,
  activeKeys: CourseState["activeKeys"] | undefined
) => {
  return useMemo(() => {
    if (!chapter || !activeKeys || !pages) {
      return null;
    }

    const totalPages = pages.length;
    const activePageIndex = pages.findIndex(
      (p) => p.attributes.key === activeKeys.pageKey
    );

    const color = chapter.color;
    const res = pages.map((p, i) => ({
      color: i <= activePageIndex ? color : inactiveColor,
      name: p.attributes.name,
      isActive: i === activePageIndex,
    }));
    return res;
  }, [chapter, activeKeys, pages]);
};
